import React from 'react';
import InvoiceDetailPresentational from './invoice-detail-presentational';
import './invoice-proof.scss';

const InvoiceDetailFunctional = () => {
	return <InvoiceDetailPresentational />;
};
export default InvoiceDetailFunctional;
